import styled, { css } from 'styled-components'
import { HTMLAttributes, PropsWithChildren } from 'react'
import { HStack } from '@musinsa/mwms-ds'
import FieldLabel from './FieldLabel'

interface Props extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode
  labelWidth?: number
  valueWidth?: number
  required?: boolean
  requiredColor?: string
}

export function FieldItem({ label, labelWidth, valueWidth, required, requiredColor, children, ...htmlDivProps }: Props) {
  const { className, ...restProps } = htmlDivProps

  return (
    <Wrap className={`field-item ${className || ''}`} {...restProps}>
      <FieldLabel required={required} requiredColor={requiredColor} content={label} width={labelWidth} />
      <InputBox className="field-item-input-box" $width={valueWidth}>
        {children}
      </InputBox>
    </Wrap>
  )
}

const Wrap = styled(HStack)`
  width: 100%;
  justify-content: space-between;
`

const InputBox = styled.div<{ $width?: number }>`
  flex: 1;
  max-width: ${({ $width }) => ($width ? `${$width}px` : 'none')};
  display: flex;
  flex-direction: column;
  justify-content: center;
`
